import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disclosure", "styleOverrides"];
import { jsx } from '@emotion/core';
import { isString } from '../../utils';
import { InfoIcon } from '../Common';
import { VENDOR_DISCLOSURE_ICON_COLORS } from './constants';
import { PayPalDisclosureItem, PayPalDisclosureList, TotalDD, TotalDL, TotalDT, VendorDisclosureContainer, VendorDisclosureText } from './StyledComponents';

var PayPalDisclosures = _ref => {
  var {
    paypal,
    styleOverrides
  } = _ref;
  return jsx(PayPalDisclosureList, {
    css: styleOverrides,
    "data-test-id": "paypal-disclosures"
  }, paypal.map((item, i) => {
    var _ref2 = isString(item) ? {
      disclosure: item
    } : item,
        {
      disclosure,
      styleOverrides
    } = _ref2,
        rest = _objectWithoutProperties(_ref2, _excluded);

    return jsx(PayPalDisclosureItem, _extends({
      className: styleOverrides,
      key: i
    }, rest), disclosure);
  }));
};

var TotalAmount = props => {
  var {
    amount,
    convertedAmount,
    isPayPalSelected
  } = props;
  return jsx(TotalDL, {
    css: props.styleOverrides
  }, jsx(TotalDT, null, props.label), jsx(TotalDD, null, isPayPalSelected ? convertedAmount : amount));
};

var VendorDisclosure = _ref3 => {
  var {
    styleOverrides,
    vendor
  } = _ref3;
  return jsx(VendorDisclosureContainer, {
    css: styleOverrides,
    "data-test-id": "vendor-disclosure"
  }, jsx(InfoIcon, {
    colors: VENDOR_DISCLOSURE_ICON_COLORS
  }), jsx(VendorDisclosureText, null, vendor));
};

export { PayPalDisclosures, TotalAmount, VendorDisclosure };